import api from './client';

export interface CreateStudyRequest {
  title: string;
  intent: string;
  hypotheses: string[];
  targetProfile?: string;
  contacts: string[];
  maxDuration?: number;
  questions?: string[];
}

export async function createStudy(data: CreateStudyRequest) {
  const res = await api.post('/api/v1/research/studies', data);
  return res.data;
}

export async function launchStudy(studyId: string) {
  const res = await api.post(`/api/v1/research/studies/${studyId}/launch`);
  return res.data;
}

export async function getStudy(studyId: string) {
  const res = await api.get(`/api/v1/research/studies/${studyId}`);
  return res.data;
}

export async function getStudyReport(studyId: string, refresh = false) {
  const res = await api.get(`/api/v1/research/studies/${studyId}/report${refresh ? '?refresh=1' : ''}`);
  return res.data;
}

export async function getStudyResponses(studyId: string) {
  const res = await api.get(`/api/v1/research/studies/${studyId}/responses`);
  return res.data;
}

export async function listStudies() {
  const res = await api.get('/api/v1/research/studies');
  return res.data;
}
